// Import Firebase modules
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Firebase configuration (replace with your config from Firebase Console)
const firebaseConfig = {
  apiKey: "AIzaSyDYzrLMEEILTV3Z8sc6N4ineLXuQx0b8V0",
  authDomain: "letscooktonight-db918.firebaseapp.com",
  projectId: "letscooktonight-db918",
  storageBucket: "letscooktonight-db918.firebasestorage.app",
  messagingSenderId: "131146964335",
  appId: "1:131146964335:web:e30d11f2bd5f95b99f1c9a",
  measurementId: "G-SEB9NQPXPS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
